module.exports = __webpack_public_path__ + "static/media/Products (15).322b7734.png";